import { HashRouter, Route, Routes } from "react-router-dom";
import { Category, Navbar, Search } from "./components/index";
import { Cuisine, Home, Recipes, Searched } from "./pages/index";

const App = () => {
  return (
    <>
      <HashRouter basename="/">
        <Navbar />
        <Search />
        <Category />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Cuisine/:type" element={<Cuisine />} />
          <Route path="/Search/:search" element={<Searched />} />
          <Route path="/recipe/:name" element={<Recipes />} />
        </Routes>
      </HashRouter>
    </>
  );
};
export default App;
